export default __webpack_public_path__ + "static/media/slider.9149b679.png";